import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root'
})
export class ReportService {

    constructor(private dataService: DataService) { }

    // getServiceProviderReportData(searchQuery: string) {
    //   return this.dataService.getReportWithParams('/api/Report/serviceProviderReportData', searchQuery)
    // }
    // getActualVsTargetReportData(searchQuery: string) {
    //   return this.dataService.getReportWithParams('/api/Report/actualVsTargetReportData', searchQuery)
    // }
    // getServiceProviderReferenceName(searchQuery: string) {
    //   return this.dataService.getLookupData('/api/Report/serviceProviderReferenceName', searchQuery)
    // }

    // getSLAReportData(searchQuery: string) {
    //   return this.dataService.getReportWithParams('/api/Report/slaReportData', searchQuery)
    // }

    getApplicationDetails(userid: number) {
        return this.dataService.getRecord('/api/Report/getApplicationDetails/' + userid)
    }

    generateRdlc(applicationId: number) {
        return this.dataService.getRecord('/api/Report/generateRdlc/' + applicationId)
    }

    // getBillingReport(searchQuery: string) {
    //   return this.dataService.getReportWithParams('/api/Report/getBillingReport', searchQuery)
    // }

    getDispatchReportPDF(searchQuery: string) {
        return this.dataService.post('/api/Report/getDispatchReportPDF', searchQuery)
    }

    getDeviceDispatchReportPDF(searchQuery: string) {
        return this.dataService.post('/api/Report/getDeviceDispatchReportPDF', searchQuery)
    }

    getCancellationReport(searchQuery: string) {
        return this.dataService.post('/api/Report/getCancellationReport', searchQuery)
    }

    getActivationReport(searchQuery: string) {
        return this.dataService.post('/api/Report/getActivationReport', searchQuery)
    }

    getCustomerReport(searchQuery: string) {
        return this.dataService.post('/api/Report/getCustomerReport', searchQuery)
    }

    getCustomerRiskReport(searchQuery: string) {
        return this.dataService.post('/api/Report/getCustomerRiskReport', searchQuery)
    }

    getShopOrdersReport(searchQuery: string) {
        return this.dataService.post('/api/Report/getShopOrdersReport', searchQuery)
    }

    submitUserBilling(searchQuery: string) {
        return this.dataService.post('/api/Report/submitUserBilling', searchQuery)
    }

    getApprovedRecurringReport(searchQuery: any) {
        return this.dataService.post('/api/Report/getApprovedRecurringReport', searchQuery)
    }

    getUnencryptedCustomerReport(searchQuery: any) {
        return this.dataService.post('/api/Report/getCustomerReportWithOutEncrption', searchQuery)
    }

    generateCancellationFee(serviceChangeRequestId: number) {
        return this.dataService.postWithQueryParms('/api/Report/generateCancellationFee/?serviceChangeRequestId='+ serviceChangeRequestId)
    }

    // getCustomerInvoiceReport(searchQuery: string) {
    //   return this.dataService.getReportWithParams('/api/Report/getCustomerInvoiceReport', searchQuery)
    // }

    // getStatementReceiptReport(searchQuery: string) {
    //   return this.dataService.getReportWithParams('/api/Report/getStatementReceiptReport', searchQuery)
    // }

    getAdditionalInformationReport(searchQuery: string) {
        return this.dataService.post('/api/Report/getAdditionalInformationReport', searchQuery)
    }

    getSuspensionReport(searchQuery: string) {
        return this.dataService.post('/api/Report/getSuspensionReport', searchQuery)
    }

    getAgeingReport(searchQuery?: string) {
        return this.dataService.post('/api/Report/getAgeingReport', searchQuery)
    }

    getCustomerInvoiceReportValue(searchQuery: any) {
        return this.dataService.post('/api/Report/getCustomerInvoiceReportValue', searchQuery)
    }

    getCustomerInvoiceReportByInvoiceNo(searchQuery: any) {
        return this.dataService.post('/api/Report/getCustomerInvoiceReportByInvoiceNo', searchQuery)
    }

    getCustomerStatementReceiptReport(searchQuery: any) {
        return this.dataService.post('/api/Report/getCustomerStatementReceiptReport', searchQuery)
    }

    getEmailForReportDropDown() {
        return this.dataService.getRecord('/api/Report/getEmailForReportDropDown');
    }

    getSpRquestedCountReport(searchQuery: string) {
        return this.dataService.post('/api/Report/getSpRquestedCountReport', searchQuery)
    }

    getsalesResellerAuditTrailReport(searchQuery: string) {
        return this.dataService.post('/api/Report/salesResellerAuditTrailReport', searchQuery)
    }

    getMovingAddressReport(searchQuery: string) {
        return this.dataService.post('/api/Report/getMovingAddressReport', searchQuery)
    }

    getCollectionsAgeingReport(searchQuery?: string) {
        return this.dataService.post('/api/Report/getCollectionsAgeingReport', searchQuery)
    }

    getPaymentArrangeReport(searchQuery?: string) {
        return this.dataService.post('/api/Report/getPaymentArrangeReport', searchQuery)
    }
    getRejectCancellationReport(data: any) {
        return this.dataService.post('/api/Report/getRejectionCancellationReport', data)
    }
    getOverdueCancellationReport(filterSearch) {
        return this.dataService.post('/api/Report/getOverdueCancellationReport/', filterSearch)
    }
    downloadCorrespondingData = function (ManageSuspensionId) {
        return this.dataService.getRecord('/api/Report/downloadCorrespondingData/' + ManageSuspensionId)
    }
    downloadRemainderMailTemplate = function () {
        return this.dataService.post('/api/Report/downloadRemainderMailTemplate')
    }
    downloadPaymentArrangement = function () {
        return this.dataService.post('/api/Report/downloadPaymentArrangementTemplate')
    }
    gettingEmailForHcReport = function () {
        return this.dataService.post('/api/Report/gettingEmailForHcReport/')
    }

    getProductandPriceExcelFile = function (id) {
        return this.dataService.getRecord('/api/Report/getProductandPriceExcelFile/' + id)
    }

    downloadSuspensionReport = function (data) {
        return this.dataService.getRecord('/api/Report/downloadSuspensionReport/' + data.manageSuspensionId + '/' + data.processType + '/' + data.batchReferenceId )
    }
}
